'use strict';
module.exports = require('./Checkbox.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/checkbox/index.js
// module id = 771
// module chunks = 7